import React, { Component } from 'react';
import Popover from '@material-ui/core/Popover';
// import JtDropDown from './../../../../commons/JtDropDown.js';
import JtMultiSelect from './../../../../commons/JtMultiSelect.js';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';

export default class JobsHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			anchorEl: null,
			open: false,
			selectedSortingOption: 'Sort By Pallet',
			selectedInwardedTimingOption: null,
			mheChecked: false,
			nonMheChecked: false,
			users: [],
			selectedUsers: [],
			showAllUsers: false
		};
		this.selected = this.selected.bind(this);
		this.toggleUserSelection = this.toggleUserSelection.bind(this);
		this.changeSorting = this.changeSorting.bind(this);
		this.changeInwardedTimingFilter = this.changeInwardedTimingFilter.bind(this);
		this.toggleMheFilter = this.toggleMheFilter.bind(this);
		this.toggleNonMheFilter = this.toggleNonMheFilter.bind(this);
		this.applyMultiSelected = this.applyMultiSelected.bind(this);
		this.assignUser = this.assignUser.bind(this);
		this.searchTextChange = this.searchTextChange.bind(this);
	}

	handleClick = placement => event => {
		if (!this.state.open) {
			this.setState({ selectedUser: null, selectedUsers: [] });
		}
		const { currentTarget } = event;
		this.setState(state => ({
			open: state.placement !== placement || !state.open,
			anchorEl: currentTarget
		}));
	};

	handleClose = () => {
		this.setState({
			open: false,
		});
	};

	componentDidUpdate(prevProps) {
		if (this.props.successScreen && this.state.open) {
			this.handleClose();
		}
		if (this.props.allUsers !== prevProps.allUsers) {
			console.log("changed");
			this.setState({ users: this.props.allUsers });
		}
	}

	changeSorting(sortingType) {
		this.setState({ selectedSortingOption: sortingType });
		this.props.selectedSorting(sortingType);
	}

	changeInwardedTimingFilter(option) {
		var newOption = (this.state.selectedInwardedTimingOption === option) ? null : option;
		this.setState({ selectedInwardedTimingOption: newOption });
		this.props.selectedInwardedTimingFilter(newOption);
	}

	toggleMheFilter() {
		var newValue = !this.state.mheChecked;
		this.setState({ mheChecked: newValue });
		if (this.props.selectedEquipmentTypeFilter) {
			this.props.selectedEquipmentTypeFilter(newValue, this.state.nonMheChecked);
		}
	}

	toggleNonMheFilter() {
		var newValue = !this.state.nonMheChecked;
		this.setState({ nonMheChecked: newValue });
		if (this.props.selectedEquipmentTypeFilter) {
			this.props.selectedEquipmentTypeFilter(this.state.mheChecked, newValue);
		}
	}

	selected(user) {
		this.setState({ selectedUser: user });
		// this.props.selected(user);
	}

	//<!--------------------------------- Multi-user assignment: selection kept by naturalId so it survives the search filter ---------------------------------!>
	toggleUserSelection(user) {
		var selectedUsers = this.state.selectedUsers;
		var isSelected = selectedUsers.some((selectedUser) => selectedUser.naturalId === user.naturalId);
		if (isSelected) {
			selectedUsers = selectedUsers.filter((selectedUser) => selectedUser.naturalId !== user.naturalId);
		} else {
			selectedUsers = selectedUsers.concat([user]);
		}
		this.setState({ selectedUsers: selectedUsers });
	}

	isUserSelected(user) {
		if (this.props.allowMultipleUsers) {
			return this.state.selectedUsers.some((selectedUser) => selectedUser.naturalId === user.naturalId);
		}
		return !!(this.state.selectedUser && this.state.selectedUser.naturalId === user.naturalId);
	}

	// Each selected job goes wholly to one user: with n jobs and more than n users, the users beyond the first n get no job.
	getIdleUsersCount() {
		if (!this.props.allowMultipleUsers) {
			return 0;
		}
		return Math.max(this.state.selectedUsers.length - this.props.selectedJobs.length, 0);
	}

	canAssign() {
		if (this.state.loading) {
			return false;
		}
		if (this.props.allowMultipleUsers) {
			return this.state.selectedUsers.length > 0;
		}
		return !!this.state.selectedUser;
	}

	applyMultiSelected(selects) {
		this.props.applyMultiSelected(selects);
	}

	assignUser() {
		this.props.assignJobs(this.props.allowMultipleUsers ? this.state.selectedUsers : this.state.selectedUser);
	}

	searchTextChange(event) {
		console.log(event.target.value);
		this.props.searchedTextChange(event.target.value);
	}

	filterList(event) {
		var updatedList = this.props.allUsers;
		updatedList = updatedList.filter(function (item) {
			return item.displayName.toLowerCase().search(event.target.value.toLowerCase()) !== -1;
		});
		this.setState({ users: updatedList });
	}

	changeUsers = (showAllUsers) => {
		this.setState({ showAllUsers: !showAllUsers }, () => {
			this.props.changeUsers(!showAllUsers);
		})
	}

	assignUserRender() {
		const { showAllUsers } = this.state;

		if (this.props.allUsers && this.state.users) {
			var heroes = this.state.users.map((hero, index) => {

				if (hero.checkedVal === undefined) {
					hero.checkedVal = false;
				}
				return (
					<div className="hero" key={index} style={{ padding: '12px 15px' }}>
						<div className="row">
							<div className="col-md-1 col-sm-1 col-xs-2">
								{(this.props.allowMultipleUsers) ?
									<Checkbox checked={this.isUserSelected(hero)} onChange={() => { this.toggleUserSelection(hero) }} value={hero.naturalId} classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }} style={{ padding: 0 }} />
									:
									<input type="radio" name="hero" checked={this.isUserSelected(hero) ? "checked" : ""} onChange={() => { this.selected(hero) }} value={hero.naturalId} classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }} />
								}
							</div>
							<div className="col-md-11 col-sm-11 col-xs-10">
								<div>{hero.displayName} ({hero.phoneNumber})</div>
							</div>
						</div>
					</div>
				)
			});


			return (
				<div style={{ width: '400px' }}>
					<div style={{ padding: '19px' }}>
						<div className="assign-title">Assign {this.props.operationName}</div>
						<div className="seperator"></div>
						<div style={{ fontSize: '13px', color: 'gray', marginTop: '8px' }}>
							<Checkbox checked={showAllUsers} onChange={(e) => { this.changeUsers(showAllUsers) }} classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }} /> <span style={{ marginRight: '5px' }}>Show All Users</span>
							{this.props.loadFetchUsers ? <CircularProgress style={{ color: '#000' }} size={15} thickness={3} /> : null}
						</div>
						<div className="filter-fc-hero" style={{ marginTop: '10px' }}>
							<input type="text" className="fc-search-box" onChange={this.filterList.bind(this)} placeholder="Search by FC Hero" /> <i className="fas fa-search" style={{ color: '#797979' }}></i>
						</div>
						<div className="fc-heroes top-ten">
							{heroes}
						</div>
					</div>
					<div className="assign-job-box">
						<div className="row">
							<div className="col-md-8">
								{(this.props.allowMultipleUsers) ?
									<div style={{ fontSize: '13px', lineHeight: '18px' }}>
										<span style={{ opacity: '0.5' }}>Selected Users :</span> {this.state.selectedUsers.length}
										{(this.getIdleUsersCount() > 0) ?
											<div style={{ color: '#797979' }}>{this.props.selectedJobs.length} job(s) for {this.state.selectedUsers.length} users: last {this.getIdleUsersCount()} selected user(s) will not get a job</div> : null
										}
									</div> : null
								}
								{(this.props.doingAssignment) ?
									<div className="pull-right">
										<CircularProgress style={{ color: '#000', lineHeight: '18px' }} size={23} thickness={3} />
									</div> : null
								}
							</div>
							<div className="col-md-4">
								<div className="pull-right">
									<button className={"btn btn-default " + (this.canAssign() ? "btn-jt-green" : "back-button")} onClick={this.assignUser} disabled={!this.canAssign()}>Assign Jobs</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		}
	}

	render() {
		const { open, anchorEl } = this.state;
		var isProductSort = this.state.selectedSortingOption === 'Sort By Product';

		return (
			<div className="putaway-header" style={{ lineHeight: 'normal' }}>
				<div>
					<div className="row">
						<div className="col-md-3">
							{(this.state.selectedSortingOption === 'Sort By Pallet') ?
								<JtMultiSelect options={this.props.allSpaces} applyMultiSelected={this.applyMultiSelected} title={'Select Pallet'} />
								:
								<div>
									<input type="text" name="search" placeholder="Search By Product Title" className="search-title-jobs" onChange={this.searchTextChange} />
								</div>
							}
						</div>
						{!isProductSort ?
							<div className="col-md-3">
								<div style={{ lineHeight: '37px', textAlign: 'right', fontSize: '16px' }}><span style={{ opacity: '0.5' }}>Selected Products :</span> {this.props.selectedJobs.length}</div>
							</div>
							: null
						}
						<div className={isProductSort ? 'col-xs-12 col-sm-9 col-md-7 no-padding-xs' : 'col-xs-6 col-sm-5 col-md-4 no-padding-xs'}>
							<div className="dropdown pull-right">
								<div className="pull-right drop-arrow dropdown-toggle" data-toggle="dropdown">
									<i className="fas fa-angle-down eighteen-font"></i>
								</div>
								<div className="pull-right drop-date dropdown-toggle no-xs-width-one-fifty" data-toggle="dropdown">
									{this.state.selectedSortingOption}
								</div>
								<ul className="dropdown-menu" style={{ width: '180px' }}>
									<li className="dropdown-data" onClick={() => this.changeSorting('Sort By Pallet')}>Sort By Pallet</li>
									<li className="dropdown-data" onClick={() => this.changeSorting('Sort By Product')}>Sort By Product</li>
								</ul>
							</div>
							{isProductSort ?
								<div className="dropdown pull-right" style={{ marginRight: '10px' }}>
									<div className="pull-right drop-arrow dropdown-toggle" data-toggle="dropdown">
										<i className="fas fa-angle-down eighteen-font"></i>
									</div>
									<div className="pull-right drop-date dropdown-toggle no-xs-width-one-fifty" data-toggle="dropdown">
										{this.state.selectedInwardedTimingOption || 'Inwarded Timing'}
									</div>
									<ul className="dropdown-menu" style={{ width: '180px' }}>
										<li className="dropdown-data" onClick={() => this.changeInwardedTimingFilter('More than 3 days')}>
											More than 3 days{this.state.selectedInwardedTimingOption === 'More than 3 days' ? ' ✓' : ''}
										</li>
										<li className="dropdown-data" onClick={() => this.changeInwardedTimingFilter('Less than 3 days')}>
											Less than 3 days{this.state.selectedInwardedTimingOption === 'Less than 3 days' ? ' ✓' : ''}
										</li>
									</ul>
								</div>
								: null
							}
							{isProductSort ?
								<div className="pull-right" style={{ display: 'flex', alignItems: 'center', marginRight: '15px', paddingTop: '10px' }}>
									<Checkbox
										checked={this.state.mheChecked}
										onChange={this.toggleMheFilter}
										value="mhe"
										classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }}
									/>
									<span style={{ fontSize: '14px', marginRight: '15px' }}>MHE</span>
									<Checkbox
										checked={this.state.nonMheChecked}
										onChange={this.toggleNonMheFilter}
										value="non-mhe"
										classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }}
									/>
									<span style={{ fontSize: '14px' }}>Non-MHE</span>
								</div>
								: null
							}
						</div>
						<div className="col-md-2">
							<button className={"btn choose-button pull-right " + (this.props.selectedJobs.length > 0 ? "btn-jt-green" : "btn-default")} onClick={this.handleClick('bottom-end')} disabled={this.props.selectedJobs.length < 1 ? "disabled" : null}>Assign {this.props.operationName} </button>
							<Popover open={open} anchorEl={anchorEl} onClose={this.handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }} classes={{ paper: 'noOverflowHidden' }}>
								{this.assignUserRender()}
							</Popover>
						</div>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/JobsHeader.js